(function () {
    'use strict';

    angular
        .module('committeeEditRoutes', [
            'committeeEditModule',
            'committeeModule'
        ])
        .config(router);

    router.$inject = ['$stateProvider', 'historyCtxtServiceProvider'];

    function router($stateProvider, historyCtxtServiceProvider) {

        $stateProvider

              // Committee Add
              .state('committeeAdd', {
                  url: '/Committee/Add',
                  templateUrl: require('./CommitteeAdd.tpl.html'),
                  controller: 'CommitteeAddController'
              })

             // Committee Not Exists
             .state('committeeNotExists', {
                 url: '/Committee/{CommitteeID:int}/NotExists',
                 templateUrl: require('./committeeNotExists.tpl.html')
             })

             // Committee Edit
             .state('committee', {
                 url: '/Committee/{CommitteeID:int}',
                 params: historyCtxtServiceProvider.getStateParamsConfig(),
                 resolve: {
                     committee: ['$stateParams', 'committeeService', function ($stateParams, service) {
                         return service.getCommittee($stateParams.CommitteeID);
                     }],
                 },
                 views: {
                     '': {
                         template: '<div ui-view="mainContent"></div>',
                         controller: 'CommitteeEditController',
                     },
                     'mainContent@committee': {
                         templateUrl: require('./CommitteeEdit.tpl.html')
                     }
                 }
             });

        // History Context
        historyCtxtServiceProvider.setCtxtState('committee',
            '/app/Main/grcEdit/committee/GOVHistoryCtxtDirective-committee.tpl.html'
        );
    }
})();
